module.exports = __webpack_public_path__ + "img/basement-washer-dryer.a1aa30c9.svg";